import React, { useState } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn } from 'mdbreact'
import BlogCategory from '../BlogCategory'
import LatestBlog from './blog/LatestBlog'
import Loading from '../loaders/Loading'
import Error from '../loaders/Error'
//graphql
import GET_CATEGORIES from '../../queries/category/blogCategories'
import { useQuery } from '@apollo/react-hooks'
import Navbar from '../Navbar'
import SEO from '../SEO'
import FooterWhite from '../FooterWhite'
import { HashLink } from 'react-router-hash-link'
import SearchModal from './SearchModal'

const Blogs = () => {
    const [show, setShow] = useState(false);
    const { data, loading, error } = useQuery(GET_CATEGORIES);

    if(loading) return <Loading/>
    if(error) return <Error/>

    return (
        <>
        <SEO title="Blog" description="A collection of Blogs, categorized and made for people to read and share." />
            <Navbar show={show} onClick={()=>setShow(!show)} page="Blogs"/>
            <div style={{ display: show ? "none" : "inline" }} className="blog-page-wrapper">
            <MDBContainer className="my-5 pb-5">
                <h1 className="h1-responsive font-weight-bold text-center">
                    Blog Collections
                </h1>
                <LatestBlog/>
                <MDBRow>
                    <MDBCol>
                        <h1 className="h1-responsive text-center font-weight-bold">
                            Image here
                            {/* <img className="w-responsive" src="https://o.remove.bg/downloads/b700241c-e83a-4c77-981d-524f57bb33f5/image-removebg-preview.png" alt=""/> */}
                        </h1>
                    </MDBCol>
                </MDBRow>
                <MDBRow className="mt-5">
                    <BlogCategory categoryData={data.blogCategories}/>
                </MDBRow>
            </MDBContainer>
        <MDBContainer fluid className="px-0 pt-5">
            <section className="p-5 grey lighten-4">
                <MDBRow className="py-5 justify-content-center">
                    <MDBCol md="10" lg="8">
                        <div className="text-center">
                            <h2 style={{ lineHeight: 1.5 }} className="h2-responsive font-weight-bold">Got Something in Mind?</h2>
                            <p className="lead">Interested in a specific content? Don't worry we got your back! Give us a call between 10am - 7pm at +63 919 9239 29. We speak English, Tagalog and Cebuano. Just let us know what you need.</p>
                            <HashLink to="/contact#contact-us">
                                <MDBBtn color="dark" className="text-capitalize">
                                    Send Message <MDBIcon fas icon="arrow-right ml-2"/>
                                </MDBBtn>
                            </HashLink>
                        </div>
                    </MDBCol>
                </MDBRow>
            </section>
        </MDBContainer>
        <FooterWhite/>
        </div>
        <SearchModal onClick={()=>setShow(false)} show={show} />
        </>
    )
}

export default Blogs
